// extracted by mini-css-extract-plugin
export default {"verticalFiller":"bank-account-history_verticalFiller__HYm2-"};